function MessageStrip() {
  return (
    <div className="w-full bg-black text-white py-4 text-center">
      <p className="text-base sm:text-lg font-semibold px-4 break-words">
        Welcome to Our Company! Experience the best services today.
      </p>
    </div>
  );
}

export default MessageStrip;
